import { render, staticRenderFns } from "./PlanPopup.vue?vue&type=template&id=07be953e&scoped=true&"
import script from "./PlanPopup.vue?vue&type=script&lang=js&"
export * from "./PlanPopup.vue?vue&type=script&lang=js&"
import style0 from "./PlanPopup.vue?vue&type=style&index=0&id=07be953e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be953e",
  null
  
)

export default component.exports